import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Maintenance.scss";

export default function Maintenance() {
  return (
    <div className="manutenzione">
      <Helmet>
        <title>Pagina in manutenzione</title>
      </Helmet>
      <h2>Pagina in manutenzione</h2>
      <p>
        Scusaci per l'inconveniente. Stiamo lavorando per migliorare il
        servizio.
      </p>
      <p>Saremo di nuovo attivi entro breve.</p>
      <Link to="/">Torna alla Homepage</Link>
    </div>
  );
}
